import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const PaymentDashboardDetailRBAC = {
  pageID: 'fc2ea66269d70d86da982f11e906ed9c',
  elementID: {
    ViewPage: '72f89f72234addde48f133ff32dd7e37',
    Refund: 'c48a2b2ff225a21e39c2e8a9ec41ec6a',
  },
} as const

export const useRBACPaymentDashboardDetailRBACPage = createUseRBAC(
  PaymentDashboardDetailRBAC.elementID,
)

export type UseRBACPaymentDashboardDetailRBACPageType = ReturnType<
  typeof useRBACPaymentDashboardDetailRBACPage
>
